//* Libraries imports
import React from "react";

type LoadingProps = {
  message?: string;
  id?: string;
};

export const Loading: React.FC<LoadingProps> = ({
  message = "Carregando...",
  id,
}) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100 vw-100 position-fixed top-0 start-0"
      id={id}
      style={{ backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 9999 }}
    >
      <div
        className="spinner-border text-primary"
        role="status"
        aria-label="Loading spinner"
      ></div>
      {message && <span className="ms-2">{message}</span>}
    </div>
  );
};
